import { AGREEMENT_STATUS_LABEL, type AgreementStatus, type OnboardingStatus, type TreatmentKind } from '@upm/domain';
import type { PillTone } from '../ui';

export function statusTone(s: OnboardingStatus): PillTone {
  switch (s) {
    case 'invited': case 'expired': return 'warn';
    case 'withdrawn': return 'neutral';
    case 'submitted': case 'kickoff_booked': return 'info';
    case 'plan_approved': case 'handed_off': return 'ok';
    default: return 'brand';
  }
}

/** An agreement's status pill (Review → Agreement card and the firm list's Agreement column). */
export function agreementTone(s: AgreementStatus): PillTone {
  switch (s) {
    case 'sent': return 'info';
    case 'firm_signed': return 'brand';
    case 'executed': return 'ok';
    case 'declined': return 'bad';
    default: return 'neutral';
  }
}

/** The newest agreement's pill (firm list and record header); "Signed" for one ticked by hand (signed outside the app). */
export function agreementPill(s: AgreementStatus | null, firmSigned: boolean): { tone: PillTone; label: string; title?: string } | null {
  if (firmSigned && s !== 'executed' && s !== 'firm_signed') return { tone: 'ok', label: 'Signed', title: 'Marked signed by hand' };
  if (!s) return null;
  const title = s === 'firm_signed' ? 'Waiting on Vertekal’s countersignature' : s === 'sent' ? 'Waiting on the firm’s signature' : undefined;
  return { tone: agreementTone(s), label: AGREEMENT_STATUS_LABEL[s], title };
}

export function treatmentTone(k: TreatmentKind): PillTone {
  switch (k) {
    case 'migrate': case 'migrate_at_freeze': return 'brand';
    case 'integrate': return 'ok';
    case 'replace': case 'replace_at_renewal': return 'purple';
    case 'review': case 'ask_on_call': return 'warn';
    default: return 'neutral';
  }
}

export const SOURCE_FILE: Record<string, { label: string; className: string }> = {
  received: { label: 'Received', className: 'font-semibold text-ok-fg' },
  needed: { label: 'Needed', className: 'font-semibold text-warn-fg' },
  from_intake: { label: 'From intake', className: 'font-semibold text-ok-fg' },
  after_plan: { label: 'After plan', className: 'text-muted' },
  decision: { label: 'Decision', className: 'text-muted' },
};
